export const alertFormSuccessMessage = "Twoje zapytanie zostało wysłane.";
export const alertFormErrorMessage = "Wystąpił problem przy wysłaniu zapytanie. Spróbuj ponownie.";
